import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {spacing} from '../theme/theme'
import {topOffset, TRANSITION_DURATION} from './consts'

export const classes = {
  overlay: css`
    position: fixed;
    z-index: 699;
    inset-block-end: 0;
    inset-inline-start: 0;
    block-size: 0;
  `,
  overlayBg: css`
    position: absolute;
    inset-block-end: 0;
    inset-inline-start: 0;
    inline-size: 100vw;
    block-size: 100vh;
    background-color: ${cssTheme.colors.absolute.black};
    opacity: 0;
    transition: background-color 200ms ease-in-out;
  `,
  overlaySwiping: css`
    transition: opacity 34ms linear;
  `,
  overlayClosed: css`
    background-color: transparent;
    pointer-events: none;
  `,
  drawerContainer: css`
    display: flex;
    position: fixed;
    inset-block-start: ${topOffset};
    inset-block-end: 0;
    inline-size: 100vw;
    transform: translateY(100vh);
    transition: transform ${TRANSITION_DURATION}ms ease-out;
    filter: drop-shadow(${cssTheme.shadows.topNormal});
    will-change: transform, transition;
    overscroll-behavior: none;
  `,
  drawerBody: css`
    position: relative;
    inline-size: 100%;
    block-size: max-content;
    max-block-size: 100%;
    overflow: hidden;
    touch-action: pan-y;
    border-radius: ${spacing(3, 3, 0, 0)};
  `,
  scrollable: css`
    overflow-y: auto;
  `,
  backBtn: css`
    position: absolute;
    inset-block-start: ${spacing(-1)};
    inset-inline-start: ${spacing(1)};
    transform: translateY(-100%);
    box-shadow: ${cssTheme.shadows.bottomNormal};
    background-color: ${cssTheme.default.day.background};
  `,
  footer: css`
    position: sticky;
    margin-inline: ${spacing(-2)};
    inset-block-end: 0;
    padding: ${spacing(1)};
    background-color: ${cssTheme.default.day.background};
    border-radius: ${spacing(3, 3, 0, 0)};
  `,
  footerStuck: css`
    filter: drop-shadow(${cssTheme.shadows.topNormal});
  `,
  insideContainer: {
    overlay: css`
      position: absolute;
      block-size: 100%;
      inline-size: 100%;
    `,
    overlayBg: css`
      inset-block-end: unset;
      inset-block-start: 0;
      inline-size: 100%;
      block-size: 100%;
    `,
    drawerContainer: css`
      position: absolute;
      inline-size: 100%;
      transform: translateY(100%);
    `,
    drawerBody: css`
      block-size: 100%;
    `,
  },
}
